import { AxiosError } from 'axios';
import Swal from 'sweetalert2';
import { persistor, store } from '../store';
import { cleanState } from '../store/ducks/auth/actions';
import { cleanStateEstoque } from '../store/ducks/estoque/actions';
import { clearCart } from '../store/ducks/estoqueCart/actions';
import { cleanStateMoviEntrada } from '../store/ducks/movimentacoes/actions';
import { cleanStateMoviSaida } from '../store/ducks/solicitacoesRetorno/actions';
import { cleanSelect } from '../store/ducks/transportadoras/actions';

import { SKW_AUTH } from '../utils/constants';

import api from './api';
import { storagePersist } from 'utils/storagePersist';
api.interceptors.request.use(
  ({ data, params, headers, ...config }) => {
    return {
      data,
      params: { ...params, accessKey: SKW_AUTH, hasTransaction: true, dev: true },
      headers: { ...headers },
      ...config,
    };
  },

  async (error: AxiosError) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data.status === 'erro') {
      Swal.fire({ title: 'Erro', html: data.response.mensagem, icon: 'error' });

      return Promise.reject(data.statusMessage);
    }

    return response;
  },
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      Swal.fire({ title: 'Sua sessão expirou!', html: '', icon: 'warning' });

      persistor.purge();
      store.dispatch(cleanState());
      store.dispatch(cleanStateEstoque());
      store.dispatch(cleanStateMoviEntrada());
      store.dispatch(cleanStateMoviSaida());
      store.dispatch(cleanSelect());
      store.dispatch(clearCart());
      storagePersist();
      localStorage.removeItem('persist:root');
      window.location.reload();
      return Promise.reject(error.response?.data);
    }

    return Promise.reject(error);
  }
);
